import apiPaths from '../api-paths';

export default {
  getComments(invoiceId, params = {}) {
    const query = Object.keys(params).length ? '?' + new URLSearchParams(params).toString() : '';
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ invoiceId }/comments${ query }`);
  },

  addComment(invoiceId, data) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/ksef/purchase-invoices/${ invoiceId }/comments`, data);
  },
};
